import { render, staticRenderFns } from "./iframe_map.vue?vue&type=template&id=5f5f604a&"
import script from "./iframe_map.vue?vue&type=script&lang=js&"
export * from "./iframe_map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports